module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-auto top-menu"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.parentId + ''
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openMenu(item)
        }
      }
    }, [_vm._v(_vm._s(item.label) + "\n      ")])]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-787be414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/top/top-menu.vue
// module id = owdz
// module chunks = 5